<template>
  <v-row class="full-height m-0p-0">
    <v-col cols="auto" class="fill-height m-0 py-0 px-0">
      <navigationPanel :fullSize="menuNav"/>
    </v-col>
    <v-col class="m-0 p-0 fill-height overflow-y-auto">
      <router-view />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import navigationPanel from '@/components/NavigationPanel.vue'

export default {
  components: {
    navigationPanel
  },
  computed: {
    ...mapGetters(['menuNav']),
    year () {
      return (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>
  .full-height {
    height: 100%;
  }
 .m-0p-0 {
    margin: 0;
    padding: 0;
 }
  .navigation-drawer {
    background-color: white;
  }
  .content {
    margin-bottom: 3rem !important;
    margin-top: 2rem !important;
    width: 100%;
    height: 100vh !important;
    min-height: 100% !important;
  }
  .footer {
    height: 1rem !important;
    margin-top: -1px !important;
    background-color: #eee !important;
  }
</style>
